import store from './../store'
import IdleJs from 'idle-js'
import Vue from 'vue'
import { trigger, triggerType } from '@/helpers/Tracker'
import { EVENT, dispatchCustomEvent } from '@/helpers/customEvents'

const idle = new IdleJs({
  idle: window._sanChatConfig?.trackIdleTimeout || 40000,
  onIdle: () => {
    if (!store.state.uistate.windowOpen && (!store.state.conversation.conversation || (store.state.conversation.conversation.convId < 1))) {
      Vue.prototype.$chatApi.getChatAvailable(store.state.uistate.lang).then(result => {
        if (result.isOpeningHours) {
          dispatchCustomEvent(EVENT.SEND.TRIGGER_NUDGING)
          trigger(triggerType.ACTION, 'ChatInactivityTrigger')
        }
      })
    }
  }
})

export { idle }
